import LocationsPageActionButton from './LocationsPageActionButton';

export default LocationsPageActionButton;
